import React, { ReactElement } from 'react';
import PaddedFlexContainer from '../padded-flex-container/padded-flex-container.component';
import ImageAvatar from '../image-avatar/image-avatar.component';
import FormatService from '../../services/format-service';
import useStylesLetterAvatar from './letter-avatar.styles';

const LetterAvatar: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    wordList,
    className,
  } = props;

  const { classes } = useStylesLetterAvatar();

  const firstLetterList: string[] = wordList.map((word: string): string => word.charAt(0));

  return (
    <PaddedFlexContainer isCentered>
      <ImageAvatar isSquare className={FormatService.formatClassNames(classes.letterAvatar, className)}>
        {firstLetterList}
      </ImageAvatar>
    </PaddedFlexContainer>
  );
});

export default LetterAvatar;
